import { buildDayNightSegments, currentCycleIndex } from '../character_stats/powerCurveUtil';

// 파워 커브 그래프 위에 캐릭터 아이콘을 놓을 위치 계산 (순수 함수).
// 지금 낮/밤 구간(강조 구간)의 가운데 분에서 각 캐릭터 곡선의 값 위치에 아이콘을 띄운다.

/**
 * 곡선(points: [{ time_bucket, smoothed_zscore }])의 minute 분 위치 값. 서로 이웃한 분(1분 차이) 사이는 직선으로 보간한다.
 * 표본이 없는 분(갭)이나 곡선 범위 밖이면 null이다.
 */
export function curveValueAt(points, minute) {
  const valid = points
    .filter((p) => p.smoothed_zscore !== null && p.smoothed_zscore !== undefined)
    .sort((a, b) => a.time_bucket - b.time_bucket);
  for (let i = 0; i < valid.length; i += 1) {
    const a = valid[i];
    if (a.time_bucket === minute) {
      return a.smoothed_zscore;
    }
    const b = valid[i + 1];
    if (b && b.time_bucket - a.time_bucket === 1 && minute > a.time_bucket && minute < b.time_bucket) {
      const ratio = (minute - a.time_bucket) / (b.time_bucket - a.time_bucket);
      return a.smoothed_zscore + (b.smoothed_zscore - a.smoothed_zscore) * ratio;
    }
  }
  return null;
}

/**
 * 지금 낮/밤 구간(그래프에서 진하게 강조되는 구간)의 가운데 분. 그래프 오른쪽 끝(maxBucket분)에서 잘린 구간은 보이는 부분의 가운데다.
 * 일차를 모르거나 그래프에 안 보이는 구간이면 null이다.
 */
export function todayMidMinute(current, maxBucket) {
  const index = currentCycleIndex(current);
  if (index === null) {
    return null;
  }
  const segment = buildDayNightSegments(maxBucket).find((s) => s.cycleIndex === index);
  return segment ? (segment.x1 + segment.x2) / 2 : null;
}

/**
 * 겹치는 아이콘을 가로로 밀어 서로 minDist 이상 떨어뜨린다(세로 위치는 곡선 값이라 그대로 둔다).
 * markers: [{ key, x, y }] (픽셀 좌표). 입력 순서와 key는 유지하고, x는 [xMin, xMax] 안으로만 움직인다.
 */
export function spreadMarkers(markers, minDist, { xMin, xMax }) {
  const placed = [];
  // 위쪽(y가 작은) 것부터 자리를 잡는다
  [...markers.keys()].sort((a, b) => markers[a].y - markers[b].y).forEach((index) => {
    const marker = markers[index];
    const free = (x) => placed.every((o) => Math.hypot(o.x - x, o.y - marker.y) >= minDist);
    let x = marker.x;
    for (let step = 1; !free(x) && step <= markers.length + 1; step += 1) {
      const candidates = [marker.x + minDist * step, marker.x - minDist * step].filter((c) => c >= xMin && c <= xMax);
      const found = candidates.find(free);
      if (found !== undefined) {
        x = found;
      }
    }
    placed.push({ ...marker, x, index });
  });
  return markers.map((_, i) => {
    const { x, key, y } = placed.find((o) => o.index === i);
    return { key, x, y };
  });
}
